import React, { Component } from 'react';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import Wentwrong from '../Wentwrong/Wentwrong';
import ReactPaginate from 'react-paginate';
import { motion, AnimatePresence } from 'framer-motion';
import Zoom from 'react-reveal/Zoom';
import { FaImages, FaEye, FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

class Allphotos extends Component {
    constructor(){
        super();
        this.state = {
            myData: [],
            error: false,
            loading: true,
            limit: 26,
            paginatedData: [],
            loadedImages: 0,
            isHovered: null,
            selectedIndex: null,
            isModalOpen: false,
        };
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
        IRestClient.GetRequest(AppUrl.allphotos).then(result => {
            if (result == null) {
                this.setState({ error: true, loading: false });
            } else {
                this.setState({
                    myData: result,
                    paginatedData: result.slice(0, this.state.limit),
                    loading: false,
                });
            }
        }).catch(() => this.setState({ error: true }));
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
        document.body.style.overflow = '';
    }

    handleKeyDown = (e) => {
        if (!this.state.isModalOpen) return;
        if (e.key === 'ArrowRight') this.nextImage();
        else if (e.key === 'ArrowLeft') this.prevImage();
        else if (e.key === 'Escape') this.closeModal();
    };

    openModal = (index) => {
        document.body.style.overflow = 'hidden';
        this.setState({ selectedIndex: index, isModalOpen: true });
    };

    closeModal = () => {
        document.body.style.overflow = '';
        this.setState({ selectedIndex: null, isModalOpen: false });
    };

    nextImage = () => {
        const total = this.state.paginatedData.length;
        this.setState(s => ({ selectedIndex: (s.selectedIndex + 1) % total }));
    };

    prevImage = () => {
        const total = this.state.paginatedData.length;
        this.setState(s => ({ selectedIndex: (s.selectedIndex - 1 + total) % total }));
    };

    handleImageLoad = () => {
        this.setState(prev => ({ loadedImages: prev.loadedImages + 1 }));
    };

    handleHover = (index) => this.setState({ isHovered: index });
    handleLeave = () => this.setState({ isHovered: null });

    handlePageClick = (data) => {
        const offset = data.selected * this.state.limit;
        this.setState({
            paginatedData: this.state.myData.slice(offset, offset + this.state.limit),
            loadedImages: 0,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    render() {
        if (this.state.loading) {
            return (
                <section style={{ position: 'relative', width: '100%', padding: '5rem 0', background: 'white', overflow: 'hidden' }}>
                    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
                        {/* Header skeleton */}
                        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                            <div className="skel" style={{ height: 32, width: 210, borderRadius: 999, margin: '0 auto 24px' }} />
                            <div className="skel" style={{ height: 50, width: 340, borderRadius: 10, margin: '0 auto 12px' }} />
                            <div className="skel" style={{ height: 50, width: 240, borderRadius: 10, margin: '0 auto 20px' }} />
                            <div className="skel" style={{ height: 4, width: 96, borderRadius: 999, margin: '0 auto 24px' }} />
                            <div className="skel" style={{ height: 15, width: 460, borderRadius: 6, margin: '0 auto 10px' }} />
                            <div className="skel" style={{ height: 15, width: 360, borderRadius: 6, margin: '0 auto' }} />
                        </div>
                        {/* Photo grid skeleton */}
                        <div className="allphotos-grid">
                            {Array.from({ length: 12 }).map((_, i) => (
                                <div key={i} className="skel" style={{ borderRadius: '1rem', aspectRatio: '1 / 1', width: '100%' }} />
                            ))}
                        </div>
                    </div>
                    <style>{`
.allphotos-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:1.5rem;}
@media(max-width:767px){.allphotos-grid{grid-template-columns:1fr;gap:1rem;}}
                    `}</style>
                </section>
            );
        }
        if (this.state.error)   return <Wentwrong />;

        const { paginatedData: pics, isModalOpen, selectedIndex, isHovered } = this.state;
        const allImagesLoaded = this.state.loadedImages >= pics.length;

        return (
            <>
                <section style={{ position: 'relative', width: '100%', padding: '5rem 0', background: 'white', overflow: 'hidden' }}>
                    <motion.div
                        style={{ position: 'relative', maxWidth: '1200px', margin: '0 auto', paddingLeft: '1rem', paddingRight: '1rem' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8 }}
                    >
                        {/* Section Header */}
                        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                            <motion.div
                                style={{ display: 'inline-flex', alignItems: 'center', padding: '0.5rem 1rem', background: '#EEF1F9', color: '#1B2B5C', fontSize: '0.875rem', fontWeight: '600', borderRadius: '9999px', border: '1px solid rgba(27,43,92,0.2)', marginBottom: '1.5rem' }}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.2, duration: 0.6 }}
                            >
                                <FaImages style={{ marginRight: '0.5rem' }} />
                                Complete Photo Collection
                            </motion.div>

                            <motion.h1
                                style={{ fontSize: 'clamp(2.25rem, 5vw, 3.75rem)', fontWeight: '900', color: '#111827', marginBottom: '1.5rem', lineHeight: '1.1', letterSpacing: '-0.025em' }}
                                initial={{ y: -20 }}
                                animate={{ y: 0 }}
                                transition={{ delay: 0.4, duration: 0.6 }}
                            >
                                Explore Our Complete
                                <span style={{ display: 'block', color: '#1B2B5C' }}>Photo Gallery</span>
                            </motion.h1>

                            <motion.div
                                style={{ width: '6rem', height: '4px', background: 'linear-gradient(to right, #2E8B54, #237A4B)', margin: '0 auto', borderRadius: '9999px' }}
                                initial={{ scaleX: 0 }}
                                animate={{ scaleX: 1 }}
                                transition={{ delay: 0.6, duration: 0.8 }}
                            />

                            <motion.p
                                style={{ fontSize: 'clamp(1.125rem, 2.5vw, 1.25rem)', color: '#4b5563', maxWidth: '48rem', margin: '2rem auto 0', lineHeight: '1.75' }}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.8, duration: 0.8 }}
                            >
                                Every image captures a moment of impact, compassion, and transformation.
                                Browse through our complete collection of photos that tell the story of our humanitarian mission.
                            </motion.p>
                        </div>

                        {/* Loading spinner */}
                        {!allImagesLoaded && (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem 0' }}>
                                <div style={{ width: '3rem', height: '3rem', border: '4px solid #C5EDDA', borderTop: '4px solid #2E8B54', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
                            </div>
                        )}

                        {/* Gallery Grid — uniform square tiles */}
                        <div className="allphotos-grid" style={{ marginBottom: '3rem' }}>
                            {pics.map((pic, index) => (
                                <Zoom key={index} top>
                                <motion.div
                                    style={{ background: 'white', borderRadius: '1rem', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
                                    onMouseEnter={() => this.handleHover(index)}
                                    onMouseLeave={this.handleLeave}
                                    whileHover={{ scale: 1.03, boxShadow: '0 16px 40px rgba(0,0,0,0.18)', transition: { duration: 0.25 } }}
                                >
                                    {/* Square image container */}
                                    <div
                                        style={{ position: 'relative', width: '100%', aspectRatio: '1 / 1', overflow: 'hidden', cursor: 'pointer' }}
                                        onClick={() => this.openModal(index)}
                                    >
                                        <img
                                            src={pic.small_image || pic.multi_image}
                                            alt={`Gallery Image ${index + 1}`}
                                            onLoad={this.handleImageLoad}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center', display: 'block', transition: 'transform 0.6s ease' }}
                                        />

                                        {/* Hover overlay */}
                                        <motion.div
                                            style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.2) 0%, transparent 50%)', opacity: 0, transition: 'all 0.5s ease' }}
                                            animate={{ opacity: isHovered === index ? 1 : 0 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div style={{ position: 'absolute', top: '1rem', right: '1rem', width: '3rem', height: '3rem', background: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(8px)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }}>
                                                <FaEye style={{ color: '#374151', fontSize: '1.125rem' }} />
                                            </div>
                                        </motion.div>
                                    </div>
                                </motion.div>
                                </Zoom>
                            ))}
                        </div>

                        {/* Pagination */}
                        {this.state.myData.length > this.state.limit && (
                            <motion.div
                                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2rem' }}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.8, duration: 0.6 }}
                            >
                                <div style={{ background: 'white', borderRadius: '1rem', padding: '1rem', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }}>
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={this.handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={Math.ceil(this.state.myData.length / this.state.limit)}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        containerClassName={'pagination justify-content-center'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                        previousClassName={'page-item'}
                                        previousLinkClassName={'page-link'}
                                        nextClassName='page-item'
                                        nextLinkClassName='page-link'
                                        breakClassName='page-item'
                                        breakLinkClassName='page-link'
                                        activeClassName='active'
                                    />
                                </div>
                            </motion.div>
                        )}
                    </motion.div>
                </section>

                {/* Lightbox — full prev/next + thumbnail strip + keyboard nav */}
                <AnimatePresence>
                    {isModalOpen && selectedIndex !== null && (
                        <motion.div
                            style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(4,4,4,0.96)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.2 }}
                            onClick={this.closeModal}
                        >
                            {/* Top bar */}
                            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1.25rem', background: 'rgba(0,0,0,0.35)', zIndex: 10 }}>
                                <span style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.875rem', letterSpacing: '0.06em' }}>
                                    {selectedIndex + 1} / {pics.length}
                                </span>
                                <button
                                    onClick={this.closeModal}
                                    style={{ background: 'none', border: 'none', color: '#fff', fontSize: '1.35rem', cursor: 'pointer', padding: '0.35rem 0.5rem', borderRadius: '6px', transition: 'background 0.2s' }}
                                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
                                    onMouseLeave={e => e.currentTarget.style.background = 'none'}
                                >
                                    <FaTimes />
                                </button>
                            </div>

                            {/* Main image */}
                            <AnimatePresence mode="wait">
                                <motion.img
                                    key={selectedIndex}
                                    src={pics[selectedIndex]?.large_image || pics[selectedIndex]?.multi_image}
                                    alt={`Gallery Image ${selectedIndex + 1}`}
                                    style={{ maxHeight: 'calc(100vh - 140px)', maxWidth: 'min(92vw, 960px)', objectFit: 'contain', borderRadius: '6px', boxShadow: '0 12px 48px rgba(0,0,0,0.55)', display: 'block' }}
                                    initial={{ opacity: 0, scale: 0.92 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.92 }}
                                    transition={{ duration: 0.22 }}
                                    onClick={e => e.stopPropagation()}
                                />
                            </AnimatePresence>

                            {/* Prev button */}
                            <button
                                onClick={e => { e.stopPropagation(); this.prevImage(); }}
                                style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', fontSize: '1.25rem', padding: '1rem 0.85rem', cursor: 'pointer', borderRadius: '8px', backdropFilter: 'blur(4px)', transition: 'background 0.2s', zIndex: 10 }}
                                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.22)'}
                                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                            >
                                <FaChevronLeft />
                            </button>

                            {/* Next button */}
                            <button
                                onClick={e => { e.stopPropagation(); this.nextImage(); }}
                                style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', fontSize: '1.25rem', padding: '1rem 0.85rem', cursor: 'pointer', borderRadius: '8px', backdropFilter: 'blur(4px)', transition: 'background 0.2s', zIndex: 10 }}
                                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.22)'}
                                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                            >
                                <FaChevronRight />
                            </button>

                            {/* Thumbnail strip */}
                            <div
                                style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '0.6rem 1rem', display: 'flex', gap: '6px', overflowX: 'auto', justifyContent: 'center', background: 'rgba(0,0,0,0.45)', scrollbarWidth: 'thin', scrollbarColor: 'rgba(255,255,255,0.25) transparent', zIndex: 10 }}
                                onClick={e => e.stopPropagation()}
                            >
                                {pics.map((item, i) => (
                                    <div
                                        key={i}
                                        onClick={() => this.setState({ selectedIndex: i })}
                                        style={{ width: '60px', height: '44px', flexShrink: 0, borderRadius: '5px', overflow: 'hidden', cursor: 'pointer', border: i === selectedIndex ? '2px solid #fdbe33' : '2px solid transparent', opacity: i === selectedIndex ? 1 : 0.55, transition: 'all 0.2s', transform: i === selectedIndex ? 'scale(1.08)' : 'scale(1)' }}
                                    >
                                        <img src={item.small_image || item.multi_image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>

                <style>{`
@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}
.allphotos-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:1.5rem;}
@media(max-width:767px){.allphotos-grid{grid-template-columns:1fr;gap:1rem;}}
`}</style>

            </>
        );
    }
}

export default Allphotos;
